var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-layout zpa-row",class:{reverse: _vm.left}},[_c('zpa-column',{staticStyle:{"overflow":"hidden"},attrs:{"no-gutter":_vm.noGutter}},[_vm._t("default")],2),_c('zpa-column',{style:({overflow: _vm.overflowFlag}),attrs:{"width":_vm.asideWidth,"height":_vm.height,"z-index":_vm.zIndex}},[_vm._t("aside")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }